module.exports = __webpack_public_path__ + "static/media/google-brands.25c83b92.svg";